const _excluded = ["user", "currentProductId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { track } from '@adsk/acs-web-analytics';
import { stylePropType } from '@adsk/alloy-react-theme';
import { EVENTS } from './helpers/const';
import { userPropType } from './helpers/types';
import { getTrackingProperties } from './helpers/utils';
import { useUserSubscriptions, useTrialMessage } from './hooks';
import TrialBannerView from './TrialBannerView';
/**
 * A TrialBanner
 * Trial banner allow to show messages and options to manage the subscriptions of the user.
 */

const TrialBanner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      user,
      currentProductId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    userTrialSubscriptions,
    showBanner
  } = useUserSubscriptions();
  const trialMessage = useTrialMessage({
    userTrialSubscriptions
  });
  const trackOpenModal = useCallback(() => {
    if (!user || !userTrialSubscriptions) return null;
    return track(EVENTS.OPEN, _objectSpread({}, getTrackingProperties(user, userTrialSubscriptions, currentProductId ? currentProductId : 'projects')));
  }, [currentProductId, user, userTrialSubscriptions]);
  return userTrialSubscriptions ? /*#__PURE__*/React.createElement(TrialBannerView, _extends({}, props, {
    ref: ref,
    message: showBanner ? trialMessage : null,
    userTrials: userTrialSubscriptions,
    displayButton: showBanner,
    onClickAnalytics: trackOpenModal
  })) : null;
});
TrialBanner.displayName = 'TrialBanner';
TrialBanner.defaultProps = {
  user: null
};
TrialBanner.propTypes = {
  /** Current Product Id */
  currentProductId: PropTypes.string,
  /** Current User */
  user: userPropType,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default TrialBanner;
//# sourceMappingURL=TrialBanner.js.map